 
<template>
    <div  :class="[prefixCls]">
        <div :class="[prefixCls + '-rel']" v-if="!(visible || always)">
            <template>
                <Tooltip transfer :content="content" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                    <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ content }}</p>
                </Tooltip>
            </template>
        </div>
        <template>
           <div :class="[prefixCls + '-popper']"
                v-if="visible || always">
                <div :class="[prefixCls + '-nc']">
                    <Tooltip transfer :content="content" :disabled="!showTooltip2" class="ivu-table-cell-tooltip">
                        <p  @click="editCfg.onClick(col,row,rowOriginal)" 
                            @on-blur="blur" 
                            ref="link" 
                            @mouseenter="handleTooltipIn2" 
                            @mouseleave="handleTooltipOut2" 
                            class="ivu-table-cell-tooltip-content table-edit-link">{{ content }}</p>
                    </Tooltip>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    const prefixCls = 'table-edit';
    import Tooltip from '../../tooltip/tooltip.vue';
    export default { 
        name: 'plugInput',
        components:{Tooltip},
        props: {
            content: {
                type: [String, Number],
                default: ''
            },
            col:[String, Number,Object],
            row: [String, Number, Object],
            rowOriginal:[String, Number, Object],
            editCfg: Object,
            disabled: {
                type: Boolean,
                default: false
            },
            visible: {
                type: Boolean,
                default: false
            },
            always: {
                type: Boolean,
                default: true
            },
            maxWidth: {
                type: [String, Number]
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                showTooltip: false,
                showTooltip2: false
            };
        },
        computed: {
        },
        watch: {
            // visible(newValue,oldValue){
            //     this.$nextTick(function(){
            //         if(newValue)this.$refs.input.focus()
            //     })
            // }
        },
        methods: {
            blur(){
                this.$emit('onChangeShowEdit',false)
            },
            handleTooltipIn () {
                const $content = this.$refs.content;
                this.showTooltip = $content.scrollWidth > $content.offsetWidth;
            },
            handleTooltipOut () {
                this.showTooltip = false;
            },
            handleTooltipIn2 () {
                const $content = this.$refs.link;
                this.showTooltip2 = $content.scrollWidth > $content.offsetWidth;
            },
            handleTooltipOut2 () {
                this.showTooltip2 = false;
            }
        },
        mounted () {
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/table/plug/link.vue